export enum SubscriptionStatus {
    Canceled = 0,
    Active = 1,
    AwaitingPayment = 2,
    Pending = 3,
}
